import { Prompt } from "react-router-dom";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { connect } from 'react-redux'
import Errors from "./../../../shared/errors";
import {
  renderCheckbox,
  renderTextField
} from "./../../../shared/form-helpers";
import required from "../../../shared/validation";
import FormErrors from "../../../shared/form-errors";
import { OnboardingStep1ClassName } from "./ducks/reducer"

let TaskStatusForm = (props) => {
  const {
    handleSubmit,
    handleDelete,
    pristine,
    submitting,
    errors,
    mode,
    submitFailed,
    invalid
  } = props;

  const thisVisualEffect = props.initialValues || {};
  const readOnly = thisVisualEffect.readOnly;

  return (
    <>
      <Prompt when={!pristine} message="" />
      {mode === "add" && <h2 className="menu-label">Add Task Status</h2>}
      {mode === "edit" && <h2 className="menu-label">Edit Task Status</h2>}
      <div className="columns">
        <div className="column">
          {errors && <Errors errors={errors} />}
          <form autoComplete="off" onSubmit={handleSubmit}>
            <Field
              name="name"
              label="Name"
              component={renderTextField}
              validate={[required]}
              required
              readOnly={readOnly}
            />
            <div className={`${OnboardingStep1ClassName}`}>
              <Field
                name="isComplete"
                label="Mark as Complete"

                component={renderCheckbox}
                readOnly={readOnly}
              />
            </div>


            {!readOnly && <div className="buttons mt-2 sticky-buttons">
              <button
                type="submit"
                className="button is-primary"
                disabled={(pristine || submitting) && !thisVisualEffect.enableSave}>
                Save
              </button>
              {mode === "edit" && (
                <>
                  <div>
                    <button
                      type="button"
                      className="button is-text"
                      disabled={submitting || !props.initialValues}
                      onClick={() => handleDelete(thisVisualEffect)}>
                      Delete Task Status
                    </button>
                  </div>
                </>
              )}
            </div>}
            <FormErrors submitFailed={submitFailed} invalid={invalid} />
          </form>
        </div>
      </div>
    </>
  );
}

TaskStatusForm = reduxForm({
  form: "TaskStatusForm",
  enableReinitialize: true
})(TaskStatusForm);

// Decorate with connect to read form values
const selector = formValueSelector('TaskStatusForm'); // <-- same as form name
const PropFormConnect = connect(
)(TaskStatusForm)

export default PropFormConnect
